
import { asaApiClient } from 'src/network/AsaApiclient';
import { groupEndPoints } from './endPoints'; 


class GroupsRepository {
    // Fetch QR code list
    getQrCodeList = async () => {
        try {
            const response = await asaApiClient.get(groupEndPoints.getQrCodeList());
            return response;
        } catch (error) {
            console.error('Error fetching QR code list:', error);
            throw error;
        }
    };

    // Fetch groups list
    getGroupList = async () => {
        try {
            const response = await asaApiClient.get(groupEndPoints.getGroupList());
            return response;
        } catch (error) {
            console.error('Error fetching groups list:', error);
            throw error;
        }
    };

    // Generate a QR code
    generateQrCode = async (groupName, channelName, userId, qrCodeText,deploymentId,knowledgeUrl) => {
        try {
            const response = await asaApiClient.post(groupEndPoints.generateQrCode(), {
                groupName,
                channelName,
                userId,
                qrCodeText,
                deploymentId,
                knowledgeUrl
            });
            return response;
        } catch (error) {
            console.error('Error generating QR code:', error);
            throw error;
        }
    };

    getKnowledgeUrlGroups = async (body) => {
        try {
            const response = await asaApiClient.post(groupEndPoints.getKnowledgeUrlGroups(), body);
            return response;
        } catch (error) {
            console.error('Error fetching knowledge url groups:', error);
            throw error;
        }
    };
}

const groupsRepository = new GroupsRepository();
export { groupsRepository as groupsRepository };
